import State from '../core/State';
import Budget from '../entity/Budget';
import PointTransactionHistory from '../entity/PointTransactionHistory';
import initialState from '../initialState';

export const setAvailablePoint = (availablePoint: number) => (state: State): State => ({
  ...state,
  bf: {
    ...state.bf,
    availablePoint,
  },
});

export const setBudgets = (budgets: Budget[]) => (state: State): State => ({
  ...state,
  bf: {
    ...state.bf,
    budgets,
  },
});

export const setPointTransactions = (pointTransactionHistory: PointTransactionHistory) => (state: State): State => ({
  ...state,
  bf: {
    ...state.bf,
    pointTransactionHistory,
  },
});

export const setChildPointTransactions = (id: string, pointTransactionHistory: PointTransactionHistory) => (
  state: State,
): State => {
  const childPointTransactionHistory = state.bf.childPointTransactionHistory
    ? state.bf.childPointTransactionHistory
    : new Map<string, PointTransactionHistory>();
  childPointTransactionHistory.set(id, pointTransactionHistory);
  return {
    ...state,
    bf: {
      ...state.bf,
      childPointTransactionHistory,
    },
  };
};

export const setChildPointTransactionsLoading = (childPointTransactionsLoading: boolean) => (state: State): State => ({
  ...state,
  bf: {
    ...state.bf,
    childPointTransactionsLoading,
  },
});

export const disposeBf = () => (state: State): State => ({
  ...state,
  currentBfOrganization: initialState.currentBfOrganization,
  bf: {
    ...initialState.bf,
  },
});
